import React from 'react';
import Border from '../base/Border';
import { getColor } from 'common/constants/_colors';
import { Flex, Padding } from '../base/layout-components';
import { SkeletonRow } from '../Skeleton';
import styled from 'styled-components';

const SkeletonRowWithMargin = styled(SkeletonRow)`
  margin-bottom: 0.8rem;
`;

const NotificationPlaceholder = () => {
  return (
    <Flex direction='row' padding='medium'>
      <Border l={`2px solid ${getColor('catskillWhite')}`}>
        <Flex direction='column' pl='small'>
          <SkeletonRowWithMargin width='10rem' />
          <SkeletonRowWithMargin width='25rem' />
          <SkeletonRowWithMargin width='20rem' />
          <SkeletonRowWithMargin width='30rem' />
          <SkeletonRowWithMargin width='28rem' />
          <Flex>
            <Padding r='small'>
              <SkeletonRowWithMargin
                borderRadius='0.5rem'
                height='2rem'
                width='10em'
              />
            </Padding>
            <SkeletonRowWithMargin
              borderRadius='0.5rem'
              height='2rem'
              width='10rem'
            />
          </Flex>
        </Flex>
      </Border>
    </Flex>
  );
};
const NotificationPlaceHolderList = () => {
  return (
    <Flex height='100%' width='100%' direction='column'>
      <NotificationPlaceholder />
      <NotificationPlaceholder />
      <NotificationPlaceholder />
    </Flex>
  );
};
export default NotificationPlaceHolderList;
